import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { SaveTicketButton } from '../actions';
import { useAppSelector } from '../../../../../app/hooks';

/**
 * TicketEditHeader - Professional header section for ticket editing
 * Contains title, description, and action buttons with dynamic ticket info
 */
export const TicketEditHeader: React.FC = () => {
  const { currentTicket } = useAppSelector(state => state.ticket);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const fromCreate = searchParams.get('fromCreate') === 'true';

  const handleGoBack = () => {
    if (fromCreate) {
      // If user came from ticket creation, go to MyTickets instead of TicketCreate
      if (account && account.name) {
        navigate(`/tickets/my-tickets?createdBy=${encodeURIComponent(account.name)}`);
      } else {
        navigate('/tickets/my-tickets');
      }
    } else {
      // Default behavior: go back in history
      navigate(-1);
    }
  };
  
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
        position: 'relative',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography 
            variant="h5" 
            component="h1" 
            fontWeight={600} 
            color="#1e293b" 
            sx={{ mb: 0.5 }}
          >
            Edit Ticket
            {currentTicket?.id && (
              <span style={{ fontWeight: 400, color: '#64748b' }}>
                {' '}{currentTicket.id}
              </span>
            )}
          </Typography>
          <Typography 
            variant="body2" 
            color="#64748b" 
            sx={{ fontSize: '0.9rem' }}
          >
            {currentTicket?.id ? (
              'Make changes to update this support ticket'
            ) : (
              'Loading ticket details...'
            )}
          </Typography>
        </Box>
        
        <Box display="flex" alignItems="center" gap={2}>
          <SaveTicketButton />
          <Button
            variant="outlined"
            onClick={handleGoBack}
            startIcon={<ArrowBackIcon />}
            sx={{
              color: '#64748b',
              borderColor: '#e2e8f0',
              fontWeight: 600,
              px: 3,
              py: 1,
              '&:hover': {
                backgroundColor: '#f8fafc',
                borderColor: '#cbd5e1'
              }
            }}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TicketEditHeader;
